import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';

export function invalidMarketPeriodBuilder({parsedStatusObj}) {
  const currentPeriod = parsedStatusObj.currentPeriod;
  const desiredPeriod = parsedStatusObj.desiredPeriod;
  const addTradePlanTime = parsedStatusObj.addTradePlanTime;
  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}>
        Cannot add this trade plan for the requested session right now. Current
        session: {currentPeriod ? currentPeriod : 'unknown'}. Requested session:{' '}
        {desiredPeriod ? desiredPeriod : 'unknown'}.{' '}
        {addTradePlanTime ? `Try again after ${addTradePlanTime}.` : ''}
      </Body3>
    </td>
  );
}
